/**
 * Default the size selection to "M" on product pages.
 *
 * The theme preselects the first available variant (usually XS). When the
 * page loads without an explicit ?variant= deep link, this selects the M
 * size input instead (when it exists and is available) by clicking it, which
 * drives the theme's normal variant-change flow (price, buy buttons, sticky
 * bar, URL). If no available M exists, the first-available default is kept.
 */
(() => {
  const PREFERRED_SIZE = 'm';

  // An explicit variant deep link (ads, shared carts) always wins.
  if (new URLSearchParams(window.location.search).has('variant')) return;

  const applyToPicker = (picker) => {
    if (picker.dataset.defaultSizeApplied === 'true') return;
    picker.dataset.defaultSizeApplied = 'true';

    for (const fieldset of picker.querySelectorAll('fieldset')) {
      const legend = (fieldset.querySelector('legend')?.textContent || '').trim().toLowerCase();
      if (!legend.includes('size')) continue;

      const checked = fieldset.querySelector('input[type="radio"]:checked');
      const preferred = Array.from(fieldset.querySelectorAll('input[type="radio"]')).find(
        (input) =>
          input.value.trim().toLowerCase() === PREFERRED_SIZE &&
          input.dataset.optionAvailable === 'true' &&
          input.getAttribute('aria-disabled') !== 'true'
      );

      if (!preferred || preferred === checked) return;
      preferred.click();
      return;
    }
  };

  const applyAll = () => {
    document.querySelectorAll('variant-picker[data-template-product-match="true"]').forEach(applyToPicker);
  };

  const run = () => {
    // Wait until the component is defined so the click is handled by the
    // picker's change flow rather than silently toggling a radio.
    customElements.whenDefined('variant-picker').then(applyAll);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run, { once: true });
  } else {
    run();
  }
})();
